import type { VariantsEntity } from '@eliadmin/core/src/api/products/types/product-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FaCheck } from 'react-icons/fa';

export function MobileStock({ variant, name }: { variant: VariantsEntity; name: string }) {
  return (
    <div className="flex w-full items-center justify-between">
      <span className={cn('text-sm font-medium text-foreground')}>{name}</span>
      <div className="flex w-full items-center justify-end">
        <div className="flex items-center justify-start gap-2.5">
          <div
            className={cn(
              'flex min-h-5 min-w-5 items-center justify-center rounded-full',
              variant.availability.id === 1 ? 'bg-[#57AE00]' : 'bg-[#FF0000]',
            )}
          >
            <FaCheck size={12} className="text-white" />
          </div>
          <p
            className={cn(
              'text-sm font-bold',
              variant.availability.id === 1 ? 'text-[#57ae00]' : 'text-[#ff0000]',
            )}
          >
            {variant.availability.name}
          </p>
        </div>
      </div>
    </div>
  );
}
